import { render, staticRenderFns } from "./ConventionObligationsSelect.vue?vue&type=template&id=07accff6&scoped=true"
import script from "./ConventionObligationsSelect.vue?vue&type=script&lang=js"
export * from "./ConventionObligationsSelect.vue?vue&type=script&lang=js"
import style0 from "./ConventionObligationsSelect.vue?vue&type=style&index=0&id=07accff6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07accff6",
  null
  
)

export default component.exports